import React, { useEffect, useState } from "react";
import Modal from "../../components/modal/Modal";
import { useNavigate, Link } from "react-router-dom";
import HowToPlay from "./HowToPlay";
import Image from "material-ui-image";
import { Paper, Button, Typography, Box, Stack, Skeleton } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LockIcon from "@mui/icons-material/Lock";
import HomeIcon from "@mui/icons-material/Home";
import { howToPlay } from "../../data/data";
import giftImage from "../../../assets/gift-box.png";
import giftImage2 from "../../../assets/gift-2.png";
import boyImage from "../../../assets/start-game-image.png";

import AuthLayout from "../../components/layout/AuthLayout";
import {
  useCheckSubscribeStatus,
  useFetchAllQuiz,
  useFetchProfile,
  useFetchRewards,
  useFetchTrialStatus,
} from "../../hooks/api/fetch";
import NoSubscription from "./NoSubscription";
import Winner from "./Winner";
import {
  useAcknowledger,
  useAcknowledgeReward,
  useAcknowledgeTrial,
  useUpdateProfile,
    useLogEvent,
} from "../../hooks/api/post";
import TrialCard from "./components/TrialCard";
import TrialSuccessCard from "./components/TrialSuccessCard";
import TrialCountdown from "./components/TrialCountdown";
import useCountdown from "../../hooks/utils/useCountdownTimer";
import UpdateEmail from "./components/UpdateEmail";
import { toast } from "react-toastify";
import SearchBar from "./components/SearchBar";
import EarnPrize from "./components/EarnPrize";
import useHomepageLogic from "./useHomepageLogic";

import EarnPointBanner from "./components/EarnPointBanner";
import GameModal from "./components/GameModal";
function Homepage() {
  const navigate = useNavigate();
  const allQuizApi = useFetchAllQuiz();
  const { mutate: logEvent } = useLogEvent();

    const [userInfo, setUserInfo] = useState(
    JSON.parse(sessionStorage.getItem("ccAuth"))
  );
    const {
    fetchGames,
    setSearchTerm,
    setClassroom_id,
    setSubject_id,
    setTopic_id,
    setIs_popular,
  } = useHomepageLogic();

 useEffect(() => {
  if (fetchGames.data) {
    sessionStorage.setItem("quizID", fetchGames.data?.data?.allGames?.[0]?.id);
  }
}, [fetchGames.data]);

useEffect(() => {
  if (!userInfo?.id) return;

  if (fetchGames.isSuccess) {
    logEvent({
      userId: userInfo.id,
      action_type: "Dashboard_Success",
    });
  } else if (fetchGames.isError) {
    const status = fetchGames?.error?.response?.status;

    if (status === 400 || status === 404) {
      logEvent({
        userId: userInfo.id,
        action_type: "Dashboard_Failed",
      });
    } else if (status === 500) {
      logEvent({
        userId: userInfo.id,
        action_type: "Dashboard_Pending",
      });
    } else {
      logEvent({
        userId: userInfo.id,
        action_type: "Dashboard_Unknown",
      });
    }
  }
}, [
  fetchGames.isSuccess,
  fetchGames.isError,
  fetchGames?.error,
  userInfo?.id,
  logEvent,
]);


  //const [userInfo, setUserInfo] = useState(
  //  JSON.parse(sessionStorage.getItem("ccAuth"))
  //);

  const rewardsAPI = useFetchRewards(userInfo?.id);
  const acknowledgeRewardAPI = useAcknowledgeReward();
  const subscriptionState = useCheckSubscribeStatus(userInfo?.userPassport);
  const [activeQuiz, setActiveQuiz] = useState(true);
  // useEffect(() => {
  //   if (subscriptionState.data?.profile_notification) {
  //     navigate("/qwiz/profile?status=update");
  //   }
  //   if (
  //     subscriptionState.data?.message === "Subscription available!" &&
  //     subscriptionState.data?.subscription?.plays > 0
  //   ) {
  //     setActiveQuiz(true);
  //   } else {
  //     setActiveQuiz(false);
  //   }
  //   return () => setActiveQuiz((active) => !active);
  // }, [subscriptionState.data]);
  const [openHowToPlayModal, setOpenHowToPlayModal] = useState(
    localStorage.getItem("hideHelp") === "true" ? false : true
  );

  const [openNoSubModal, setOpenNoSubModal] = useState(
    localStorage.getItem("newbie") === "yes" ? true : false
  );
  const [quizInfo, setQuizInfo] = useState();
  const [gamePlayModal, setGamePlayModal] = useState(false);
  const fetchProfile = useFetchProfile(userInfo?.id);
  function handleGameCardClick(id, quiz) {
    if (!activeQuiz) {
      setOpenNoSubModal(true);
    } else {
      // navigate(`/qwiz/gameplay?id=${id}`);
      if (localStorage.getItem("hideHelp") !== "true") {
        setOpenHowToPlayModal(true);
      }
      sessionStorage.setItem("quizID", id);
      setQuizInfo((quizes) => ({
        title: quiz?.title,
        id: quiz?.id,
        summary: quiz?.description,
        time: quiz?.quiz_duration,
        questionCount: quiz?.quiz_question_number,
        quizType: "game" || quiz?.quizType,
      }));
      setGamePlayModal(true);
    }
  }

  function handleCloseHowToPlayModal() {
    setOpenHowToPlayModal(false);
  }
  function handleCloseNoSubModal() {
    setOpenNoSubModal(false);
    localStorage.setItem("newbie", "no");
  }

  const [openWinningModal, setOpenWinningModal] = useState(false);
  useEffect(() => {
    const winnings = rewardsAPI?.data?.winning;
    if (winnings?.length > 0 && winnings?.[0]?.isSeen === 0) {
      setOpenWinningModal(true);
    }
  }, [rewardsAPI?.data?.winning]);
  function handleCloseWinningModal() {
    acknowledgeRewardAPI.mutate({ user_id: userInfo.id });
    setOpenWinningModal((modal) => !modal);
  }

  const [trialSuccess, setTrialSuccess] = useState(false);
  const acknowledgeTrialSuccess = useAcknowledgeTrial();
  function closeTrialModal() {
    setTrialSuccess(false);
    acknowledgeTrialSuccess.mutate({
      phoneNumber: userInfo?.userPassport,
    });
  }
  const fetchTrialStatus = useFetchTrialStatus({
    phone_number: userInfo?.userPassport,
  });
  const { countDown } = useCountdown(
    new Date(fetchTrialStatus.data?.subscription_end)
  );
  // console.log({ fetchTrialStatus, countDown });

  useEffect(() => {
    let data = fetchTrialStatus.data;
    if (data) {
      setTrialSuccess(
        data?.subscription?.tier_congratulation_status === "opened"
          ? true
          : false
      );

      if (
        data?.hasFeedback === false &&
        data?.subscription_elapse === "00:00:00" &&
        data?.subscription?.is_free_trier === 1
      ) {
        navigate("/qwiz/feedback");
      }
    }
  }, [fetchTrialStatus.data]);

  function convertDate(date) {
    let newDate = new Date(date);
    return `${newDate.getDate()}/${newDate.getMonth() + 1} ${newDate
      .getHours()
      .toString()
      .padStart(2, "0")}:${newDate.getMinutes().toString().padStart(2, "0")}`;
  }

  const [showUpdateEmail, setShowUpdateEmail] = useState(false);

  useEffect(() => {
    // Api to let us know when to update profile
    if (false) {
      if (!!fetchProfile.data?.user?.email) {
        setShowUpdateEmail(false);
      } else {
        setShowUpdateEmail(true);
      }
    }
  }, [fetchProfile.data]);

  const [newEmail, setNewEmail] = useState("");
  const updateProfileApi = useUpdateProfile();
  function hideUpdateEmailModal() {
    updateProfileApi.mutate(
      {
        userId: userInfo.id,
        data: {
          name: fetchProfile.data.user.name,
          email: newEmail,
          display_name: fetchProfile.data.user.display_name,
          avatar: fetchProfile.data.user.avatar,
          first_login: false,
        },
      },
      {
        onSuccess: () => {
          toast.dismiss();
          toast.success("Avatar updated successfully");
          // sessionStorage.setItem(
          //   "ccAuth",
          //   JSON.stringify({ ...userProfile, avatar: newAvatar })
          // );
          // handleCloseAvatarModal();
        },
        onError: (err) => {
          toast.error("Avatar update failed");
        },
      }
    );
    setShowUpdateEmail(false);
  }
  const [viewAll, setViewAll] = useState(false);

  // const [isGameModalOpen, setGameModalOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Show modal after 5 seconds initially, then every 5 minutes
    const initialTimer = setTimeout(() => {
      setShowModal(true);
    }, 5000);

    const intervalTimer = setInterval(() => {
      setShowModal(true);
    }, 300000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  const handleFiltersApply = (filters) => {
    // console.log(filters, "filters");
    setTopic_id(filters.topic_id || "");
    setIs_popular(filters.is_popular || false);
    fetchGames.refetch();
  };

  return (
    <AuthLayout data-testid="authLayout">
      {((fetchTrialStatus.data?.subscription?.is_free_trier === 1 &&
        fetchTrialStatus.data?.subscription_elapse === "00:00:00") ||
        fetchTrialStatus.data?.subscription?.tier_status === "opened") && (
        <TrialCard
          isExpired={
            fetchTrialStatus.data?.subscription?.is_free_trier === 1 &&
            fetchTrialStatus.data?.subscription_elapse === "00:00:00"
              ? true
              : false
          }
          expiryDate={fetchTrialStatus.data?.subscription_end}
          // expiryDate={fetchTrialStatus.data?.subscription_status}
        />
      )}
      {fetchTrialStatus.data?.subscription?.is_free_trier === 1 &&
        fetchTrialStatus.data?.subscription_elapse !== "00:00:00" && (
          <TrialCountdown
            expiryDate={fetchTrialStatus.data?.subscription_end}
            minutes={countDown.minutes}
            seconds={countDown.seconds}
            hours={countDown.hours}
          />
        )}      <Link to="/qwiz/earn-points">
        <EarnPrize />
      </Link>
      <SearchBar
        setSearchTerm={setSearchTerm}
        setClassroom_id={setClassroom_id}
        setSubject_id={setSubject_id}
      />
      <Box
        sx={{
          padding: "15px",
          minHeight: "calc(100vh - 220px)",
          backgroundColor: "#F8F8F8",
          marginTop: "40px",
          borderTopLeftRadius: "40px",
          borderTopRightRadius: "40px",
        }}
      >
        <div className="flex justify-between items-center mb-4 px-4">
          <Typography
            variant="h4"
            fontWeight={900}
            fontSize={16}

            // onClick={() => setActiveQuiz((act) => !act)}
          >
            {" "}
            Current Quiz
          </Typography>

          <button
            className="text-[#F24444] font-semibold"
            onClick={() => setViewAll((prev) => !prev)}
          >
            {viewAll ? "Hide" : "View All"}
          </button>
        </div>
        {fetchGames?.isLoading && <SkeletonCard />}

        {!fetchGames?.isLoading && (
          <>
            {fetchGames?.data?.data?.allGames?.length > 0 ? (
              fetchGames?.data?.data?.allGames
                ?.slice(0, viewAll ? undefined : 3)
                .map((quiz) => (
                  <GameCard
                    key={quiz?.id}
                    id={quiz?.id}
                    title={quiz?.title}
                    summary={quiz?.description}
                    icon={quiz?.avatar}
                    time={quiz?.quiz_duration}
                    onClick={() => handleGameCardClick(quiz?.id, quiz)}
                    status={activeQuiz}
                    questionCount={quiz?.quiz_question_number}
                    quizType={quiz?.quizType}
                  />
                ))
            ) : (
              <div className="flex flex-col items-center justify-center mt-6">
                <p className="text-gray-500 text-sm mb-3">
                  No games available at the moment.
                </p>
                <button
                  onClick={() => {
                    setTopic_id(""); 
                    setIs_popular(false); // clear topic filter}
                    // setFilters(null); // clear filter state
                    fetchGames.remove(); // remove cached data
                    fetchGames.refetch(); // fetch again with no filters
                  }}
                  className="px-4 py-2 bg-[#61A641] text-white rounded-lg hover:bg-[#61A641]/50 transition"
                >
                  Fetch Games
                </button>
              </div>
            )}
          </>
        )}

        {/* <GameCard
          title="Spelling Buzz QUiz"
          summary="Test your spelling skills in our Spelling Bee Quiz. Compete to become the ultimate word champion!"
          icon={giftImage}
          time="3"
          onClick={() => navigate("/qwiz/gameplay")}
        /> */}

        {/* Modals */}
        <NoSubscription
          title="No Plays left"
          open={openNoSubModal}
          handleClose={handleCloseNoSubModal}
        />

        <TrialSuccessCard
          title="Congratulations"
          subtitle=" Your one-day free trial has been successfully activated."
          open={trialSuccess}
          handleClose={closeTrialModal}
          trialStart={
            convertDate(fetchTrialStatus.data?.subscription_start)
            // ?.split("T")
            // ?.join(" ")
            // ?.replace("2024-", "")
            // ?.replace(".000Z", "")
            // ?.replaceAll("-", "/")
          }
          trialEnd={
            convertDate(fetchTrialStatus.data?.subscription_end)
            // ?.replace("2024-", "")
            // ?.replaceAll("-", "/")
          }
        />
        <GamePlayModal
          open={gamePlayModal}
          handleClose={() => setGamePlayModal(false)}
          quiz_type={quizInfo?.quizType}
          key={quizInfo?.id}
          id={quizInfo?.id}
          title={quizInfo?.title}
          summary={quizInfo?.summary}
          time={quizInfo?.time}
          questionCount={quizInfo?.questionCount}
        />
        {/* <HowToPlay
          options={howToPlay}
          open={openHowToPlayModal}
          handleClose={handleCloseHowToPlayModal}
        /> */}
        <Winner
          open={openWinningModal}
          title="Congratulations 🎉"
          content="You have won ₦5, 000 and payment will made to account ending 5738 within 24 hours"
          image={giftImage2}
          buttonText="Back to Home"
          buttonColor="error"
          buttonVariant="contained"
          buttonIcon={<HomeIcon />}
          buttonFunction={handleCloseWinningModal}
          handleClose={handleCloseWinningModal}
        />
      </Box>
      {showUpdateEmail && (
        <UpdateEmail
          handleClose={hideUpdateEmailModal}
          setNewEmail={setNewEmail}
        />
      )}{" "}
      <GameModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onApply={handleFiltersApply}
      />
    </AuthLayout>
  );
}

export default Homepage;











export function GameCard({
  key,
  title,
  icon,
  summary,
  time,
  status,
  onClick,
  questionCount,
}) {
  return (
    <Paper
      key={key}
      sx={{
        position: "relative",
        borderTopRightRadius: "15px",
        cursor: "pointer",
        mb: 2,
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          position: "absolute",
          top: "0",
          right: "0",
          background: status ? "#61A641" : "#F24444",
          borderTopRightRadius: "15px",
        }}
      >
        <Typography
          variant="body2"
          fontSize={14}
          sx={{ color: "white", padding: "11px" }}
        >
          {status ? "Unlocked" : "Locked"}
        </Typography>
      </Box>
      {!status && (
        <Box
          sx={{
            position: "absolute",
            top: "60px",
            right: "20px",
          }}
        >
          <LockIcon color="error" />
        </Box>
      )}
      <Stack direction="row" alignItems={"center"} gap={2} p={1}>
        <Box height={72} width={72}>
          <Image src={icon} color="transparent" />
        </Box>
        <Box sx={{ maxWidth: "202px" }}>
          <Typography variant="h6" fontSize={14} fontWeight={600} mt={1} mb={1}>
            {title}
          </Typography>
          <Typography variant="body1" fontSize={10} fontWeight={300} mb={1}>
            {summary}
          </Typography>

          {!!time ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <AccessTimeIcon />
              <Typography variant="body1" fontSize={10} ml={1}>
                {time} mins
              </Typography>
              <Typography variant="body1" fontSize={10} ml={1}>
                / {questionCount} questions
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Stack>
    </Paper>
  );
}
function SkeletonCard() {
  return (
    <Stack spacing={1}>
      {/* For variant="text", adjust the height via font-size */}
      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      {/* For other variants, adjust the size with `width` and `height` */}
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="rectangular" width={210} height={60} />
      <Skeleton variant="rounded" width={210} height={60} />
    </Stack>
  );
}

function GamePlayModal({
  open,
  handleClose,
  title,
  id,
  summary,
  time,
  questionCount,
  quiz_type,
}) {
  return (
    <Modal open={open} handleClose={handleClose} width={"446px"}>
      <Box p={2}>
        <Typography
          mt={1}
          variant="h3"
          fontSize={20}
          fontWeight={900}
          // align="center"
        >
          Let's Play {title}
        </Typography>
        <Box py={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Box width={100}>
            {/* <Image
              aspectRatio={9 / 16}
              src={boyImage}
              color="transparent"
              alt="boy with opened arm"
            /> */}
          </Box>
        </Box>
        <Typography
          variant="body1"
          fontSize={14}
          fontWeight={500}
          // align="center"
        >
          <h3 className="font-semibold text-xl mb-3">Description</h3>
          {summary}
        </Typography>
        {!!time ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AccessTimeIcon />
            <Typography
              ml={1}
              variant="body2"
              fontSize={12}
              fontWeight={900}
              align="center"
            >
              {time}mins
            </Typography>
            <Typography
              ml={1}
              variant="body2"
              fontSize={12}
              fontWeight={900}
              align="center"
            >
              / {questionCount} questions
            </Typography>
          </Box>
        ) : null}
        <Box
          my={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link
            to={
              quiz_type === "game"
                ? `/qwiz/playgame?id=${id}`
                : `/qwiz/gameplay?id=${id}`
            }
          >
            <Button
              variant="contained"
              color="success"
              sx={{ backgroundColor: "#614a641" }}
            >
              Start Game
            </Button>
          </Link>
        </Box>
      </Box>
    </Modal>
  );
}
